module.exports = __webpack_public_path__ + "img/yingxiao_line_bg.428a6df3.png";